import React from 'react';
import Form from '../../../molecules/Form';
import { RequestActivityFormTemplate } from './RequestActivityFormTemplate';
import IForm from '../../../../types/IForm';

type RequestActivityFormProps = {
  form: IForm;
  translationNamespace: string;
  refreshBlock: () => void;
};

export function RequestActivityForm({ form, translationNamespace, refreshBlock }: RequestActivityFormProps) {
  return (
    <Form id="teamroom-request-activation-form" model={form} submittableWithoutChange>
      <RequestActivityFormTemplate translationNamespace={translationNamespace} refreshBlock={refreshBlock} />
    </Form>
  );
}
